
import axios from '@/config/httpConfig'
// 查询用户界面设置信息
export function getUserInterface(data) {
    return axios.post('/user/getUserInterface', data)
}
// 保存用户界面设置
export function saveUserInterface(data) {
    return axios.post('/user/saveUserInterface', data)
}  